import { useEffect } from 'react';
import { setupProductHomepageTask, ViewProductEnterpriseSection, ViewProductSections } from './tasks';
export const useProductPageTelemetry = _ref => {
  let {
    productId,
    productInfo,
    isEnterpriseAppsSectionLoadError,
    enterpriseAppsSectionData,
    areSectionsLoading,
    isSectionsLoadError,
    sectionsData,
    sectionsDataError,
    enterpriseAppsSectionDataError
  } = _ref;
  useEffect(() => {
    const showEnterpriseSection = !!productInfo.showEnterpriseAppsSection;
    const ProductPageTask = setupProductHomepageTask(showEnterpriseSection);
    ProductPageTask.start();
    if (showEnterpriseSection) {
      ViewProductEnterpriseSection.start();
    }
  }, [productId, productInfo.showEnterpriseAppsSection]);
  useEffect(() => {
    if (isEnterpriseAppsSectionLoadError) {
      ViewProductEnterpriseSection.failed(enterpriseAppsSectionDataError);
    }
    if (enterpriseAppsSectionData) {
      ViewProductEnterpriseSection.succeeded();
    }
  }, [isEnterpriseAppsSectionLoadError, enterpriseAppsSectionData, enterpriseAppsSectionDataError]);
  useEffect(() => {
    if (areSectionsLoading) {
      ViewProductSections.start();
    }
    if (isSectionsLoadError) {
      ViewProductSections.failed(sectionsDataError);
    }
    if (sectionsData) {
      ViewProductSections.succeeded();
    }
  }, [areSectionsLoading, isSectionsLoadError, sectionsData, sectionsDataError]);
};